import React from 'react'
import {useApi, useApiSession} from "../ApiSession";
import {useNavigate} from "react-router-dom";

export const NavBar = () => {

    const session = useApiSession()

    const navigate = useNavigate()

    return <>
        <nav
            className="bg-white dark:bg-gray-900 fixed w-full z-20 top-0 start-0 border-b border-gray-200 dark:border-gray-600">
            <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
                <a href="/" className="flex items-center space-x-3 rtl:space-x-reverse">
                    <span className="self-center text-2xl font-semibold whitespace-nowrap dark:text-white">/</span>
                </a>
                <div className="flex md:order-2 space-x-3 md:space-x-0 rtl:space-x-reverse"></div>
                <div className="items-center justify-between hidden w-full md:flex md:w-auto md:order-1" id="navbar-sticky">
                    <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
                        <li>
                            <a href="/pipelines/not-ready"
                               className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500"
                               aria-current="page">Pending Pipeline</a>
                        </li>
                        <li>
                            <a href="/pipelines/running"
                               className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500"
                               aria-current="page">Running Pipelines</a>
                        </li>
                        <li>
                            <a href="/pipelines/stopped"
                               className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500"
                               aria-current="page">Stopped Pipelines</a>
                        </li>
                        <li>
                            <a href="/pipelines/createNew"
                               className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500"
                               aria-current="page">Create New Pipeline</a>
                        </li>
                        <li>
                            <a href="/"
                               className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500"
                               aria-current="page">All Pipelines</a>
                        </li>
                        <li>
                            <a
                                className="block py-2 px-3 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 md:dark:text-blue-500"
                                aria-current="page"
                                onClick={() => {
                                    session.logout().then(() => {
                                        navigate("/login")
                                    })
                                }}
                            >Logout</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <div style={{marginTop: 80}}></div>
    </>
}